module.exports = __webpack_public_path__ + "static/img/特色创新.7917754a.png";